import React from 'react';
import { bool } from 'prop-types';
import { LeftFilterWrapper } from '../../common';
import Filters from './Filters';

const DesktopFilters = ({ reseting, ...props }) => (
    <LeftFilterWrapper reseting={reseting} defaultOpened>
        <Filters {...props} />
    </LeftFilterWrapper>
);

DesktopFilters.propTypes = {
    reseting: bool
};

DesktopFilters.defaultProps = {
    reseting: false
};

export default DesktopFilters;
